export default __webpack_public_path__ + "static/media/collections_3.ac55a439.webp";